import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environment/environment';
import { ASSOCIATE_HTTP, isAssociateHttpRequest } from '../associate/auth/associate-http.context';

function disabledRequest(req: HttpRequest<unknown>, feature: string): Observable<HttpEvent<unknown>> {
  return throwError(
    () =>
      new HttpErrorResponse({
        status: 0,
        statusText: 'Feature disabled',
        url: req.url,
        error: { message: `${feature} is disabled.` },
      }),
  );
}

function isMemberAllocationTrailUrl(url: string): boolean {
  return url.includes('/employees/') && url.includes('/allocation-history');
}

function isTaskAllocationTrailUrl(url: string): boolean {
  return url.includes('/assignment-history');
}

function isClientPortalUrl(url: string): boolean {
  return (
    url.includes('/pm/client-access/') ||
    url.includes('/associate/') ||
    (url.includes('/client-users/') && url.includes('/invitations'))
  );
}

function isProjectDiscussionUrl(url: string): boolean {
  return /\/projects\/[^/?]+\/discussions(?:\/|$|\?)/.test(url);
}

/**
 * Drops HTTP for features gated by environment flags so callers cannot
 * reach the network even if UI still invokes a service method.
 */
@Injectable()
export class FeatureFlagInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = req.url;
    if (environment.enableMemberAllocationTrail !== true && isMemberAllocationTrailUrl(url)) {
      return disabledRequest(req, 'Member allocation trail');
    }
    if (environment.enableTaskAllocationTrail !== true && isTaskAllocationTrailUrl(url)) {
      return disabledRequest(req, 'Task allocation trail');
    }
    if (
      environment.enableClientPortal !== true &&
      (isAssociateHttpRequest(req.context.get(ASSOCIATE_HTTP)) ||
        isClientPortalUrl(url) ||
        isProjectDiscussionUrl(url))
    ) {
      return disabledRequest(req, 'Client portal');
    }
    return next.handle(req);
  }
}
